<template>
  <div>
    <div v-if="listData.data[listData.page]" class="text-center">
      <ul class="text-center ceramics-content clearfix">
        <transition-group name="ceramicsFade">
          <li
            class="relative"
            v-for="list in listData.data[listData.page]"
            :key="list.id"
          >
            <div class="ceramics-content-detailed w-full h-full">
              <div
                v-if="list.thumbnail_url"
                class="ceramics-content-detailed-img w-full cursor-pointer"
                :style="
                  'background-image:url(' +
                    list.thumbnail_url +
                    ');' +
                    imgNoOverflow(list.thumbnail_url)
                "
                alt="pic"
                @click="openModal(list)"
              ></div>
              <div
                v-else
                class="text-center no-img cursor-pointer"
                @click="openModal(list)"
              >
                暂无图片
              </div>
              <div
                class="ceramics-content-detailed-info text-center cursor-default"
              >
                {{ list.name }}
              </div>
            </div>
          </li>
        </transition-group>
      </ul>
      <div class="pag text-center">
        <paginate
          class="clearfix"
          v-model="listData.page"
          :page-count="listData.pageCount"
          :page-range="3"
          :margin-pages="2"
          :click-handler="clickCallback"
          :prev-text="''"
          :next-text="''"
          prev-class="page-prev"
          next-class="page-next"
          :container-class="'pagination'"
          :page-class="'page-item'"
        >
        </paginate>
      </div>
    </div>
    <div v-else class="text-center no-data">暂无数据</div>
    <!-- 正常弹框 -->
    <CeramicsModal :data="modalData" :uuid="uuid"></CeramicsModal>
  </div>
</template>

<script>
import CeramicsModal from '@/components/ceramics/CeramicsModal'
import { getCeramics } from '@/core/api'
import paginateFilter from '@/core/mixins/paginateFilter'

export default {
  name: 'ceramic',
  components: {
    CeramicsModal
  },
  mixins: [paginateFilter],
  props: {
    data: {},
    type: null,
    pageSize: null,
    uuid: null
  },
  data() {
    return {
      ceramics: null,
      listData: {
        data: [],
        total: 0, // 总数
        page: 1, // 第几页
        pageSize: 16, //每页条数
        pageCount: 0
      },
      modalData: {}
    }
  },
  computed: {
    ceramicsCollections() {
      let data = this.$store.getters['SubscriberStore/ceramicsCollections']
      return data
    },
    isLogin() {
      let subscriber = this.$store.getters['SubscriberStore/subscriber']
      let client = this.$store.getters['SubscriberStore/client']
      return subscriber && client && subscriber.open_id && client.mobile
    }
  },
  watch: {
    data() {
      this.ceramicsFilter()
    },
    ceramicsCollections() {
      this.getListData()
    },
    uuid() {
      this.openModal({ id: this.uuid })
    }
  },
  mounted: function() {
    this.getListData() // 拿到所有数据
  },
  methods: {
    // 瓷器列表 数据过滤
    ceramicsFilter() {
      let conditions = this.data
      let ceramicsObj = {}
      if (!this.ceramics) {
        return
      }
      if (!conditions) {
        return
      }
      this.ceramics.forEach(ceramic => {
        let isShow = true
        for (let key in conditions) {
          if (conditions[key].length > 0) {
            isShow = conditions[key].some(item => {
              if (Array.isArray(ceramic[key])) {
                return ceramic[key].indexOf(item) !== -1
              } else {
                return ceramic[key] === item
              }
            })
            if (!isShow) {
              break
            }
          }
        }
        if (isShow) {
          ceramicsObj[ceramic.id] = ceramic
        }
      })

      let newListData = []
      for (let ceramic in ceramicsObj) {
        newListData.push(ceramicsObj[ceramic])
      }
      this.$set(this.listData, 'data', newListData)

      this.listData = this.paginateFilter(this.listData)
    },
    imgNoOverflow(url) {
      let img = new Image()
      img.src = url
      let w = img.width,
        h = img.height
      if (w <= h || (w > h && w / h < 246 / 177)) {
        return 'background-size: auto 100%'
      } else {
        return 'background-size: 100% auto;'
      }
    },
    // 弹出modal
    openModal(list) {
      this.modalData = JSON.parse(JSON.stringify(list))
    },

    // 获取瓷器列表
    async getListData() {
      let _this = this
      if (this.pageSize) {
        this.listData.pageSize = this.pageSize
      }
      let res = await getCeramics('', {})
      if (res.status === 200) {
        this.listData.total = res.total || res.data.length
        // 过滤掉没有zip包 或 没有正摄图的(image_url) 的数据,并添加是否收藏的数据
        let arr = []
        res.data.forEach(currentValue => {
          if (
            (currentValue.models && currentValue.models.length !== 0) ||
            currentValue.image_url
          ) {
            if (this.ceramicsCollections) {
              let collect = _this.ceramicsCollections.filter(
                item => item.id === currentValue.id
              )
              currentValue.collection = collect.length > 0 ? true : false
            }

            arr.push(currentValue)
          }
        })
        res.data = arr
        // 瓷器收藏列表，过滤没有被收藏的数据
        if (this.type && this.type === 'collection') {
          res.data = res.data.filter(item => item.collection)
        }
        this.listData.data = res.data
        this.ceramics = JSON.parse(JSON.stringify(res.data))
        this.listData = this.paginateFilter(this.listData)
        this.ceramicsFilter()
      }
    },
    // 分页切换
    clickCallback(pageNum) {
      document.body.scrollIntoView()
      this.listData.page = pageNum
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.ceramicsFade-enter-active,
.ceramicsFade-leave-active {
  transition: all 0.35s;
  -moz-transition: all 0.35s; /* Firefox 4 */
  -webkit-transition: all 0.35s; /* Safari 和 Chrome */
  -o-transition: all 0.35s; /* Opera */
}
.ceramicsFade-enter,
.ceramicsFade-leave-to {
  opacity: 0;
}
.pag {
  padding: 24px 0 80px 0;
}
.ceramics-content {
  width: calc(100% + 20px);
  li {
    float: left;
    text-align: left;
    width: 25%;
    height: 330px;
    padding: 0 20px 20px 0;
  }
}

.ceramics-content-detailed {
  position: relative;
  .ceramics-content-detailed-img {
    height: 89%;
    background-position: center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-color: $c-ceramic-search-bg;
    border: 5px solid $c-ceramic-li-bg;
  }
}
.ceramics-content-detailed-info {
  margin-top: 5px;
  width: 100%;
  height: 27px;
  line-height: 27px;
  position: absolute;
  bottom: 0;
  left: 0;
  color: $c-white;
  font-size: 14px;
}

.no-img {
  line-height: 16;
  color: $c-white;
  height: 89%;
  background-color: $c-ceramic-search-bg;
  border: 5px solid $c-ceramic-li-bg;
}
</style>
